
import axios from '../../config/axiosConfig';
import { CREATE_BEAM, GET_BEAMS, BEAM_REQUEST, DELETE_BEAM, UPDATE_BEAM, BEAM_REQUEST_FAILURE, GET_BEAMS_WITH_DETAIL } from '../types';

export const getBeams = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BEAM_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth?.company?.id, finyearId: auth?.finyear?.id };
            // if (!auth?.company?.Common_Master) {
            //     params = { ...params, companyId: auth.company?.id }
            // }
            return axios.get('/beam/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BEAMS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getBeamsWithRemainingTakaMeter = (productionId) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BEAM_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, productionId, companyId: auth.company?.id };
            // if (!auth?.company?.Common_Master) {
            //     params = { ...params, companyId: auth.company?.id }
            // }
            return axios.get('/beam/getAllWithRemainingTakaMeter', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BEAMS_WITH_DETAIL, payload: response.data });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createBeam = (beam) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BEAM_REQUEST });
            axios.post(
                '/beam/add',
                beam,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, finyearId: auth?.finyear?.id } }
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_BEAM, payload: response.data });
                } else {
                    dispatch({ type: BEAM_REQUEST_FAILURE, error: 'Beam create failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateBeam = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BEAM_REQUEST });
            return axios.put('/beam/update', { id, data }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_BEAM, payload: { id, data: response.data } }, { params: { userId: auth.user?.id }});
                } else {
                    dispatch({ type: BEAM_REQUEST_FAILURE, error: 'Beam update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteBeam = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: BEAM_REQUEST });
            axios.delete(`/beam/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_BEAM, id: id });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BEAM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};